/** Dispatched when `ConsentBanner` persists accept/decline (same tab — `storage` does not fire). */
export const CODEMERLIN_ANALYTICS_CONSENT_CHANGED = 'codemerlin-analytics-consent-changed';
